import Cookies from "js-cookie";
import {cookieDomain, cookieSameSite, cookieSecure} from "./constants";

export type ThemePreferenceMode = "light" | "dark" | "auto";
export type ResolvedThemeMode = "light" | "dark";

export const themeStorageKey = "admin-id-express-theme";
export const themeCookieKey = "idexpress_theme";

const cookieOptions = {
  expires: 365,
  sameSite: cookieSameSite,
  secure: cookieSecure,
  domain: cookieDomain,
};

export const normalizeThemePreference = (theme?: string | null): ThemePreferenceMode | "" => {
  if (theme === "light" || theme === "dark" || theme === "auto") return theme;
  if (theme === "system") return "auto";
  return "";
};

export const resolveThemePreference = (theme: ThemePreferenceMode): ResolvedThemeMode => {
  if (theme === "light" || theme === "dark") return theme;
  const hour = new Date().getHours();
  return hour >= 7 && hour < 19 ? "light" : "dark";
};

export const getInitialThemePreference = (): ThemePreferenceMode => {
  if (typeof window === "undefined") return "auto";
  return normalizeThemePreference(localStorage.getItem(themeStorageKey)) ||
    normalizeThemePreference(Cookies.get(themeCookieKey)) ||
    "auto";
};

export const persistThemePreference = (theme: ThemePreferenceMode) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(themeStorageKey, theme);
  Cookies.set(themeCookieKey, theme, cookieOptions);
};
